import { useDispatch, useSelector } from 'react-redux';

// selectors
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';

// libraries
import { kebabCase } from '@makemydeal/dr-common-utils';

// constants
import type { DriveLineEnums } from '../../../constants';
import { DRIVE_LINE, DriveLineOptions, ZERO_WIDTH_SPACE } from '../../../constants';

// components
import { Typography } from '@interstate/components/Typography';
import { SelectInput } from '@interstate/components/SelectInput';

// styling
import { DetailContainer } from '../trade.style';
import { useSingleTradeInFormProvider } from '../MultiTradeIn/TradeInFormProvider';

interface DriveLineFieldProps {
    hasTradeIn: boolean;
    isManualFormOpen: boolean;
    disabled?: boolean;
}

export const getDriveLineShortName = (name: DriveLineEnums) => DriveLineOptions.find((item) => item.value === name)?.label;

export const DriveLineField: React.FC<DriveLineFieldProps> = ({ hasTradeIn, isManualFormOpen, disabled }) => {
    const { tradeInIndex } = useSingleTradeInFormProvider();
    const dispatch = useDispatch();
    const driveLine = useSelector(tradeInsSelectors.getDriveLine(tradeInIndex));

    const onChange = (event: any) => {
        dispatch(tradeInsActionCreators.updateTradeInDriveLine(event.target.value, tradeInIndex));
    };

    return (
        <>
            {isManualFormOpen ? (
                <SelectInput
                    options={DriveLineOptions}
                    placeholder="Select"
                    displayDeselectOption={true}
                    label={DRIVE_LINE}
                    data-testid={kebabCase(DRIVE_LINE)}
                    name={kebabCase(DRIVE_LINE)}
                    onChange={onChange}
                    value={driveLine}
                    disabled={disabled}
                    size="sm"
                />
            ) : (
                <>
                    {hasTradeIn && (
                        <DetailContainer>
                            <Typography variant="label-md" color="sem.color.on-surface.muted" sx={{ marginBottom: '8px' }}>
                                {DRIVE_LINE}
                            </Typography>
                            <Typography variant="body-md" tag="span" data-testid="trade-driveline-value-label">
                                {getDriveLineShortName(driveLine as DriveLineEnums) || ZERO_WIDTH_SPACE}
                            </Typography>
                        </DetailContainer>
                    )}
                </>
            )}
        </>
    );
};
